import ajax from '../../../components/ajax';
export default function useProductApi(productId) {
    function request() {
        return ajax(`/api/product/${productId}`, {})
            .then(response => response.json());
    }
    return { request };
}
